class MMainnav {
	/** @param {HTMLElement} element */
	constructor(element) {
		this.headerElement = element.closest('.o-header');
		this.buttonElements = element.querySelectorAll(':scope > ul > li > button');
		this.popoverElements = this.headerElement.querySelectorAll('[data-popover-id][data-stack="1"]');

		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'attributes') {
					// Toggle aria-pressed when hidden attribute changes
					[...this.buttonElements]
						.filter((_) => _.dataset.popovertarget === mutation.target.dataset.popoverId)
						.forEach((_) => _.setAttribute('aria-pressed', !mutation.target.hidden));
				}
			});
		});

		this.popoverElements.forEach((popoverElement) => {
			observer.observe(popoverElement, {
				attributes: true,
			});
		});

		this.buttonElements.forEach((buttonElement) => {
			buttonElement.addEventListener('click', () => {
				const popoverTargetElement = [...this.popoverElements]
					.find((_) => _.dataset.popoverId === buttonElement.dataset.popovertarget);
				this.hideOtherPopovers(popoverTargetElement);

				popoverTargetElement?.toggleAttribute('hidden', buttonElement.getAttribute('aria-pressed') === 'true');
			});
		});
	}

	hideOtherPopovers(exceptElement = null) {
		const { headerElement } = this;
		[...headerElement.querySelectorAll('[data-popover-id][data-stack="1"]')]
			.filter((_) => _ !== exceptElement)
			.forEach((_) => _.toggleAttribute('hidden', true));
	}
}

// eslint-disable-next-line no-new
new MMainnav(document.querySelector('.m-mainnav'));
